import React from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import MoneyIcon from "@material-ui/icons/Money";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _SearchResultTable } from "../components";
import { _DateField } from "../form";
import { GetInvoicesListColumns } from "../components/SearchTableColumns/InvoicesListColumns";
import useTable from "../hooks/Table";

export const _InvoicesList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_FatturaDatiEconomici: "", Identificativo: "", DataRiferimentoDocumento: "", Creato: "" });
    const { Data, Options, IsLoading } = useTable("/api/FatturaDatiEconomici/ricerca", FormData);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={MoneyIcon} Title="FattureDatiEconomici">
                    <a href="/Contabilita/FattureDatiEconomici/0">
                        <Tooltip title={Trad.Trad("Nuovo")}>
                            <IconButton size="small" aria-label="add">
                                <AddIcon color="action" />
                            </IconButton>
                        </Tooltip>
                    </a>
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_FatturaDatiEconomici"
                                    label={Trad.Trad("ID")}
                                    value={FormData.ID_FatturaDatiEconomici}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="Identificativo"
                                    label={Trad.Trad("Identificativo")}
                                    value={FormData.Identificativo}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField
                                    Value={FormData.DataRiferimentoDocumento || ""}
                                    Name="DataRiferimentoDocumento"
                                    Label="DataRiferimento"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField Value={FormData.Creato || ""} Name="Creato" Label="Creato" OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_SearchResultTable Data={Data} Columns={GetInvoicesListColumns()} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/InvoicesList.tsx